import React, { Component } from 'react'
import './App.sass';
import './variables.scss';
import './fonts.css';
import SearchFilters from './components/SearchFilters/SearchFilters';
import WeeklyCalendar from './components/WeeklyCalendar/WeeklyCalendar';
require('es6-promise').polyfill();
require('isomorphic-fetch');
require('url-search-params-polyfill');

export default class App extends Component {

  constructor(props) {
    super(props);

    this.state = {
      firstLoad: true,
      isFetching: false,
      adulti: true,
      labels: [],
      adultiList: [],
      bambiniList: [],
      queryParam: "",
      daySelected: 0
    }
  }

  setQueryParam = (query) => {
    this.setState({
      queryParam: query
    })
  }

  setDaySelected = (day) => {
    this.setState({
      daySelected: day
    })
  }

  handleClick = (adulti) => {
    this.setState({
      adulti: adulti
    }, () => this.callAPI("resetCategory"))
  }

  componentDidMount = () => {
    const { labels } = this.state
    if (labels.length > 0)
      this.callAPI()
    else
      this.callLabels()
  }

  queryStringNormalize = () => {
    let params = new URLSearchParams(window.location.search);
    let str = ""
    str += params.get("category")!= null ? "&category=" + params.get("category") : ""
    str += params.get("sede")!= null ? "&seats=" + params.get("sede") : ""
    str += params.get("attivita")!= null ? "&courses=" + params.get("attivita") : ""
    str += params.get("anno")!= null ? "&year=" + params.get("anno").split(",",1) : ""
    str += params.get("day")!= null ? "&activeday=" + params.get("day") : ""
    str += params.get("seats")!= null ? "&seats=" + params.get("seats") : ""
    str += params.get("courses")!= null ? "&courses=" + params.get("courses") : ""
    str += params.get("year")!= null ? "&year=" + params.get("year").split(",",1) : ""
    str += params.get("activeday")!= null ? "&activeday=" + params.get("activeday") : ""
    str += params.get("datainizio")!= null ? "&datainizio=" + params.get("datainizio") : ""
    str += params.get("datafine")!= null ? "&datafine=" + params.get("datafine") : ""
    //console.log("str","?"+str.substring(1));

    return (str.substring(1))
  }

  callLabels = () => {
    const { labels } = this.state
    if (labels.length == 0) {
      // fetch('http://localhost:3000/services/labels.json')
        fetch('/_vti_bin/CalendarService/CalendarService.svc/GetCalendarLabels')
        .then(response => {
          return response.json()
            .then(json => {
              this.setState({
                labels: json.data
              })
              this.callAPI()
            })
            .catch(error => {
              console.log('Looks like there was a problem: \n', error);
            });
        })
    } else {
      return true
    }
  }

  callAPI = (type, extraInfo) => {

    const { adultiList, queryParam, bambiniList,firstLoad } = this.state

    let adulti = this.state.adulti
    
    let urlParams = type == "resetCategory" ? (adulti ? "category=adulti" : "category=ragazzi") : (firstLoad ?  new URLSearchParams(window.location.search) : "");
    if (firstLoad) {
      
      
      this.setState({
        adulti: firstLoad && urlParams.get("category") != undefined && urlParams.get("category").length > 0 && urlParams.get("category") == "ragazzi" ? false : true,
        firstLoad: false
      }, () => {
        adulti = this.state.adulti
      });

      }

    this.setState({
      isFetching: true,
      adultiList: [],
      bambiniList: []
    })

    // let baseUrl = urlParams.toString().length > 0 ? "http://localhost:3000/services/ragazzi.json?" + (firstLoad ? this.queryStringNormalize(urlParams.toString()):urlParams.toString()) : (!adulti ? 'http://localhost:3000/services/ragazzi.json?category=ragazzi' : 'http://localhost:3000/services/adulti.json?category=adulti');
    let baseUrl = urlParams.toString().length > 0 ? "/_vti_bin/CalendarService/CalendarService.svc/GetCalendar?" + (firstLoad ? this.queryStringNormalize(urlParams.toString()): urlParams.toString()) : (!adulti ? '/_vti_bin/CalendarService/CalendarService.svc/GetCalendar?category=ragazzi' : '/_vti_bin/CalendarService/CalendarService.svc/GetCalendar?category=adulti')
    let url = ""
    
    switch (type) {
      case 'changeSelect':
        url = `${baseUrl}&activeday=${adulti ? adultiList[0].currentWeek.daysOfWeek[this.state.daySelected].currentWeekDay : bambiniList[0].currentWeek.daysOfWeek[this.state.daySelected].currentWeekDay}${queryParam}`
        break
      case 'prevWeek':
        url = `${baseUrl}&activeday=${adulti ? adultiList[0].currentWeek.daysOfWeek[extraInfo].previousWeekDay + adultiList[0].currentWeek.prevWeek : bambiniList[0].currentWeek.daysOfWeek[extraInfo].previousWeekDay + bambiniList[0].currentWeek.prevWeek}${queryParam}`
        break
      case 'nextWeek':
        url = `${baseUrl}&activeday=${adulti ? adultiList[0].currentWeek.daysOfWeek[extraInfo].nextWeekDay + adultiList[0].currentWeek.nextWeek : bambiniList[0].currentWeek.daysOfWeek[extraInfo].nextWeekDay + bambiniList[0].currentWeek.nextWeek}${queryParam}`
        break
      default:
        url = baseUrl;
    }
    fetch(url)
      .then(response => {
        this.setState({
          isFetching: false
        })
        if (!response.ok) {
          throw Error(response.statusText);
        }
        return response.json()
      })
      .then(json => {
       
        if (adulti) {
          this.setState({
            adultiList: json.data
          })

        } else {
          this.setState({
            bambiniList: json.data
          })
        }
      })
      .catch(error => {
        this.setState({
          isFetching: false
        })
        console.log('Looks like there was a problem: \n', error);
      });
  }


  render() {
    const { adultiList, bambiniList, adulti, isFetching, labels } = this.state

    return (
      <>
        {

          <div className="calendar-app">
            <div className="calendar-app-header">
              <div className="menu">
                <a href="#" className={`menu-item ${!adulti ? "active" : ""}`} onClick={() => this.handleClick(false)}>
                  {labels.calendar_categories_boys}
                </a>
                <a href="#" className={`menu-item ${adulti ? "active" : ""}`} onClick={() => this.handleClick(true)}>
                  {labels.calendar_categories_adults}
                </a>
              </div>
            </div>
            <div id="calendar-content" className="calendar-content">
            {
              (adulti && adultiList && adultiList.length > 0 || !adulti && bambiniList && bambiniList.length > 0) && !isFetching ?
                <>
                  {

                    (adulti ? <SearchFilters setQueryParam={this.setQueryParam} adulti={this.state.adulti} labels={labels} callbackApplyFilter={(type) => this.callAPI(type)} callbackReset={this.callAPI} itemsList={adultiList[0]} /> : <SearchFilters setQueryParam={this.setQueryParam} adulti={this.state.adulti} labels={labels} callbackApplyFilter={(query) => this.callAPI(query)} callbackReset={this.callAPI} itemsList={adultiList[0]} callbackReset={this.callAPI} itemsList={bambiniList[0]} />)

                  }
                  <WeeklyCalendar setDaySelected={this.setDaySelected} labels={labels} callbackChangeWeek={(type, extraInfo) => this.callAPI(type, extraInfo)} weekList={adulti ? adultiList[0] : bambiniList[0]} resultsList={adulti ? adultiList[0] : bambiniList[0]} />
                </>
                : <div className="loading"></div>
            }
            </div>
          </div>
        }
      </>
    )
  }
}

